"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _effect = _interopRequireDefault(require("../effect.js"));
var _api = require("../api");
var _selectCompay = _interopRequireDefault(require("../../../supplier/coupons/selectCompay.vue"));
var _amount = require("@/utils/amount");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  components: {
    SelectCompay: _selectCompay.default
  },
  mixins: [_effect.default],
  props: {
    companyList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    adminUserOptions: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      dialogFormVisible: false,
      form: {
        customerEmpList: {
          list: []
        },
        orderType: 1,
        exeType: '1',
        fuConfig: '',
        projectNumber: '',
        companyId: '',
        companyName: '',
        salesPrice: 0,
        sendTypeName: ''
      },
      pageFrom: {
        page: 1,
        limit: 15,
        id: null
      },
      cardAllocations: []
    };
  },
  computed: {
    creatorDisplayName: function creatorDisplayName() {
      var _this = this;
      if (!this.form.creatorId) {
        return '';
      }
      var creator = this.adminUserOptions.find(function (item) {
        return String(item.id) === String(_this.form.creatorId);
      });
      return creator ? creator.realName : this.form.creatorId;
    },
    auditLogList: function auditLogList() {
      return Array.isArray(this.form.auditLogList) ? this.form.auditLogList : [];
    },
    validTimeRange: function validTimeRange() {
      if (this.form.validStartTime && this.form.validEndTime) {
        return "".concat(this.form.validStartTime, " - ").concat(this.form.validEndTime);
      }
      return '';
    },
    orderTypeText: function orderTypeText() {
      if (this.form.orderType === 1) {
        return '福卡充值';
      } else if (this.form.orderType === 2) {
        return '权益卡包';
      }
      return '未知类型';
    },
    cardInfo: function cardInfo() {
      if (this.form.fuCardId && this.form.fuCardName) {
        return "ID:".concat(this.form.fuCardId, " - ").concat(this.form.fuCardName);
      }
      return this.form.fuCardId || '';
    },
    couponPackageInfo: function couponPackageInfo() {
      if (this.form.couponPackageId && this.form.couponPackageName) {
        return "ID:".concat(this.form.couponPackageId, " - ").concat(this.form.couponPackageName);
      }
      return this.form.couponPackageName || '';
    },
    // 根据 companyId 显示公司名称
    companyDisplayName: function companyDisplayName() {
      var _this2 = this;
      // 如果有 companyId，尝试从 companyList 列表中查找
      if (this.form.companyId && this.companyList && this.companyList.length > 0) {
        var company = this.companyList.find(function (item) {
          return item.id === _this2.form.companyId;
        });
        if (company && company.name) {
          return company.name;
        }
      }
      // 如果找不到，则使用 innerCompanyName 作为兜底
      return this.form.innerCompanyName || '-';
    }
  },
  methods: {
    open: function open(id) {
      this.pageFrom.id = id;
      this.getInfo();
      this.dialogFormVisible = true;
    },
    close: function close() {
      this.dialogFormVisible = false;
    },
    handleSizeChange: function handleSizeChange(size) {
      this.pageFrom.limit = size;
      this.getInfo();
    },
    pageChange: function pageChange(page) {
      this.pageFrom.page = page;
      this.getInfo();
    },
    getInfo: function () {
      var _getInfo = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _this$form, res, customerEmpTypeMap, configObj, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              _context.n = 1;
              return (0, _api.infoApi)(this.pageFrom);
            case 1:
              res = _context.v;
              console.log('获取到的详情数据:', JSON.stringify(res));

              // 处理新的API返回格式，从data字段获取详情数据
              if (res.data) {
                this.form = res.data;
              } else {
                this.form = res; // 兼容旧格式
              }

              // 确保 customerEmpList 有默认值，避免模板读取 null
              if (!this.form.customerEmpList) {
                this.form.customerEmpList = {
                  list: [],
                  total: 0
                };
              }

              // 确保公司ID正确设置
              console.log('接口返回的公司信息:', this.form.companyId, this.form.companyName);
              customerEmpTypeMap = {
                1: '全员发放',
                2: '全员回收',
                3: '指定发放',
                4: '指定回收'
              };
              this.form.customerEmpType = customerEmpTypeMap[(_this$form = this.form) === null || _this$form === void 0 ? void 0 : _this$form.customerEmpType] || '';

              // 解析卡片分配配置
              if (this.form.fuConfig && this.form.orderType === 2) {
                try {
                  configObj = typeof this.form.fuConfig === 'string' ? JSON.parse(this.form.fuConfig) : this.form.fuConfig;
                  if (configObj && configObj.allocations && Array.isArray(configObj.allocations)) {
                    this.cardAllocations = configObj.allocations;
                  }
                } catch (err) {
                  console.error('解析卡片配置失败:', err);
                  this.cardAllocations = [];
                }
              }
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              this.$message.error(_t.message);
            case 3:
              return _context.a(2);
          }
        }, _callee, this, [[0, 2]]);
      }));
      function getInfo() {
        return _getInfo.apply(this, arguments);
      }
      return getInfo;
    }(),
    viewCouponDetail: function viewCouponDetail(couponId) {
      if (!couponId) return;

      // 打开新页面跳转到优惠券详情
      var routeUrl = this.$router.resolve({
        path: "/marketing/coupon/detail/".concat(couponId)
      });
      window.open(routeUrl.href, '_blank');
    },
    formatYuanColumn: function formatYuanColumn(row, column, cellValue) {
      return (0, _amount.formatToYuan)(cellValue);
    },
    formatAuditResult: function formatAuditResult(row) {
      var auditResultMap = {
        1: '审核通过',
        2: '审核驳回'
      };
      return auditResultMap[Number(row.auditResult)] || '--';
    }
  }
};